import { render, staticRenderFns } from "./orderMgt.vue?vue&type=template&id=cf5a8ff0&scoped=true&"
import script from "./orderMgt.vue?vue&type=script&lang=js&"
export * from "./orderMgt.vue?vue&type=script&lang=js&"
import style0 from "./orderMgt.vue?vue&type=style&index=0&id=cf5a8ff0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf5a8ff0",
  null
  
)

export default component.exports